import { put, takeLatest, call } from 'redux-saga/effects';
import URL from 'url';
import * as apiMarketplace from '../../api/marketplaces';
import * as actNotif from '../notifications/actions';
import { showProgressBar, hideProgressBar } from '../moka/actions';
import { setApp, setIsMokaOpenApiRedirect } from './actions';
import { OPEN_PLATFORM_LOGIN_REPLACE_VIEW } from './types';

export function* replaceViewFlow(action) {
  yield put(setIsMokaOpenApiRedirect({ isMokaOpenApiRedirect: true }));

  const {
    payload: { next },
  } = action;
  const { query } = URL.parse(next);

  // split the 'next' query string into json
  const paramAsStrings = query.split('&');
  const params = {};
  paramAsStrings.forEach(p => {
    const [k, v] = p.split('=');
    params[k] = v;
  });
  if (params && params.client_id) {
    try {
      yield put(showProgressBar());
      const response = yield call(apiMarketplace.getAppDetail, {
        id: params.client_id,
      });
      yield put(setApp({ app: response.data.data.app }));
    } catch (e) {
      yield put(actNotif.error(e.message));
    } finally {
      yield put(hideProgressBar());
    }
  }
}

export default function* saga() {
  yield takeLatest(OPEN_PLATFORM_LOGIN_REPLACE_VIEW, replaceViewFlow);
}
